import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutSessionComponent } from './layout-session/layout-session.component';
import { RouterModule } from '@angular/router';
import { LayoutBlankComponent } from './layout-blank/layout-blank.component';
import { LayoutRestrictAreaComponent } from './layout-restrict-area/layout-restrict-area.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { LayoutRestrictAreaSidebarComponent } from './layout-restrict-area/sidebar/layout-restrict-area-sidebar.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedPipesModule } from '@app-shared/pipes/shared-pipes.module';
import { SharedDirectivesModule } from '@app-shared/directives/shared-directives.module';
import {CalculateService} from "@app-services/calculate.service";
import { HeaderComponent } from './layout-restrict-area/header/header.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
@NgModule({
	declarations: [
		LayoutSessionComponent,
		LayoutBlankComponent,
		LayoutRestrictAreaComponent,
		LayoutRestrictAreaSidebarComponent,
  HeaderComponent
	],
	imports: [ReactiveFormsModule, MatInputModule, MatAutocompleteModule, CommonModule, RouterModule, PerfectScrollbarModule, NgbModule, SharedPipesModule, SharedDirectivesModule, MatSelectModule, MatFormFieldModule],
    exports: [LayoutSessionComponent, LayoutRestrictAreaComponent, LayoutBlankComponent, LayoutRestrictAreaSidebarComponent],
	providers: [CalculateService]
})
export class LayoutsModule {}
